<template>
  <div class="buy-shop-member">
    <div class="price">您需要支付<span class="num"> {{ giftDetail.giftSellPrice || '' }} 元</span>，即可开通“店铺会员”</div>
    <div class="text">
      <van-checkbox
          class="buy-shop-member-checkbox"
        v-model="checked"
        ref="checkboxes"
        slot="right-icon"
      >
        <span>我已阅读并同意</span>
      </van-checkbox>
      <span class="link" @click.self="goShopAgreement">《云柑社区云店服务协议》</span>
    </div>

    <div class="btn-con" v-if="giftDetail.disPlay===2">
      <div class="btn" @click="placeShopMemberOrder">确定支付 ￥{{ giftDetail.giftSellPrice || '' }}</div>
    </div>

    <ant-pay ref="antpay" :show="show" :showPayType="true" :paynum="paynum" :payData="payData" @close="onPayClose" @onPay="onPay" />
  </div>
</template>

<script>
import { giftInfo } from '@/api/member'
import { placeShopMemberOrder } from '@/api/mall/mallOrder'
import { getPaySignInfo } from '@/api/pay/payApi'
import AntPay from '@/components/antpay/antpay'
export default {
  components: {
    AntPay
  },
  data(){
    return {
      checked: true,
      giftDetail: {},//礼包详情
      orderNo: null,//预览订单号
      show: false, // 支付框
      paynum: '￥0.00',
      payData: {},//支付数据

      disabledOrder: false,//是否禁止点击确认支付按钮
      pageToast: null,
    }
  },
  created(){
    this.getGiftInfo()
  },
  methods: {

    //获取是否拥有店铺会员功能
    getGiftInfo(){
      let req = {shopId: this.$route.query.shopId}
      if(this.session('userOpenId')){
        req.openid=this.session('userOpenId')
      }
      giftInfo(req).then(res=>{
        if(res.code===200){
          this.giftDetail = res.data
        }
      })
    },

    // 预下单
    placeShopMemberOrder(){
      if(this.disabledOrder){
        return false
      }
      console.log(this.disabledOrder)
      this.disabledOrder = true;
      this.pageToast = this.$toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true,
        onClose:()=>{
          this.disabledOrder = false;
        }
      });
      let req = {shopId: this.$route.query.shopId}
      if(this.$route.query.inviteUserId){
        req.inviteUserOpenId = this.$route.query.inviteUserId
      }
      placeShopMemberOrder(req).then(res=>{
        if(res.code===200){
          this.orderNo = res.data.orderNo
          this.paynum = '￥' + this.giftDetail.giftSellPrice.toFixed(2)
          this.payData ={
            amount: this.giftDetail.giftSellPrice, // 支付金额
            orderNo: this.orderNo, // 订单号
            orderType: 1, // 订单类型，0：直播点卡，1：商城购物 ,
            userOpenid: this.session('userOpenId'),
          };
          this.show = true
        }
          this.pageToast.clear()
      })
    },

    goShopAgreement(){
      window.location.href = '//www.anttalk.vip/agreement/shop'
    },

    // 支付弹框相关
    onPayClose(){
      this.show = false
    },

    onPay(obj){
      console.log('关闭弹框后的obj:',obj);
      this.show = false;
      this.payData.payType = obj.payType;
      this.payData.userOpenid = this.session('userOpenId');

      if(obj.payType==='blcPay'){ // 余额支付
        this.payData.payPassword = obj.payPassword
        this.payData.walletType = 0; //钱包类型，0：个人钱包，1：店铺钱包
      }
      if(obj.payType==='blcPay'){ // 余额支付
        getPaySignInfo(this.payData).then(res=>{
          if(res.code===200){
            this.$refs.antpay.$success('支付成功！')
            window.setTimeout(()=>{
              this.$router.push({name: 'mallShopMember', query: this.$route.query})
            },1500)
          }else {
            this.$refs.antpay.$close(res.message)
          }
        })
      }else if(obj.payType==='wxJSAPI'){ // 微信支付
        let wxPay = obj;
        wxPay.wxPayType = '店铺会员礼包';
        wxPay.shopId = this.$route.query.shopId;
        if(this.$route.query.inviteUserId){
          wxPay.inviteUserId = this.$route.query.inviteUserId;
        }
        this.session('wxPay', wxPay)
        this.$router.push({name: 'wxPay'})

      }
    }
  }
}
</script>

<style lang="less" scoped>
.buy-shop-member{
  .price{
    font-size: 15px;color: #2b2b2b;line-height: 54px;padding: 0 20px;
    .num{
      color: rgb(248,53,53);
    }
  }
  .text{
    font-size: 10px;color: #999;padding-left: 20px;
    display: flex;
    .link{
      color: rgb(41,142,219);
      display: inline-flex;
      line-height: 20px;
      align-items: center;
      font-size: 12px;
      padding: 14px 0;
    }
    .buy-shop-member-checkbox{
      display: inline-flex;
      font-size: 12px;
    }
  }
  .btn-con{
    padding: 30px 20px 20px;
    .btn{
      width: 100%;height: 44px;border-radius: 5px;
      display: flex;justify-content: center;align-items: center;
      color: #fff;background-color: #1296db;font-size: 18px;
    }
  }
}
</style>